// extracted by mini-css-extract-plugin
export var copyright = "footer-module--copyright--e5100";
export var dropdownCustomChevron = "footer-module--dropdown-custom-chevron--ef60d";
export var footer = "footer-module--footer--03d8a";
export var footerLogo = "footer-module--footer-logo--47d28";
export var infoDropdown = "footer-module--info-dropdown--9a7d0";
export var socialIconsTitle = "footer-module--social-icons-title--5c0c7";
export var socialIconsWrapper = "footer-module--social-icons-wrapper--a3797";
export var socialWrapper = "footer-module--social-wrapper--1d641";